"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
require("reflect-metadata");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
/**
 * Decorate a field as a list of primitive values
 *
 * @param prototype {Function}
 * @constructor
 */
var List = function (prototype) {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        var instances = value === null || value === void 0 ? void 0 : value.map(function (element) {
                            if (element === null || element === undefined) {
                                return element;
                            }
                            return prototype(element);
                        });
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, instances, this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.List = List;
//# sourceMappingURL=List.js.map